module.exports = {
    states : ["To Do", "In Progress", "Review Required", "In Review", "Supervisor Review Required", "Supervisor Review", "Completed", "Archived"],
}